module.exports = __webpack_public_path__ + "static/media/circle-cropped.0e42d7fb.png";